import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

import { areaNameSchema } from "@/pages/areas/schemas/area";

/**
 * The fields AutoForm renders. The part and the display names have their own controls
 * (a select over the city's parts, a per-locale editor) and live beside this in {@link AreaForm}.
 */
export const areaEditSchema = z.object({
  name: areaNameSchema.superRefine(
    fieldConfig({
      label: "Name",
      description: "At most 40 characters, no comma.",
    }),
  ),
  keepOldNameAsAlias: z
    .boolean()
    .default(true)
    .superRefine(
      fieldConfig({
        label: "Keep the old name as an alias",
        description: "Only used when the name changes.",
      }),
    ),
});

export type AreaEditFormType = z.infer<typeof areaEditSchema>;

export interface AreaForm extends AreaEditFormType {
  parentId?: string;
  partOrder?: number;
  displayNames: Record<string, string>;
}
